const DEFINED = "998e6888-830c-11e9-a53c-0242ac120002";
const FORMULAIC = "9cdef848-830c-11e9-a53c-0242ac120002";
export const aggregateInterestMethods = [
  { name: "Defined", value: DEFINED, sortOrder: 0 },
  { name: "Formulaic", value: FORMULAIC, sortOrder: 1 }
];
export {
  DEFINED,
  FORMULAIC
};
